<div class="base-chats-list">
  <div class="base-chats-list__header">
    <h1 class="base-chats-list__title">
      {{ title }}
    </h1>

    <app-actions [mode]="'menu'" [items]="createMenuItems">
      <button
        tuiIconButton
        class="button button_add"
        type="button"
        appearance="icon"
        iconStart="@tui.circle-plus"
        size="s"
      ></button>
    </app-actions>
  </div>

  <div class="base-chats-list__list">
    <div class="header">
      <app-search [(searchQuery)]="searchQuery" (searchQueryChange)="searchQueryChangeHandler($event)"></app-search>
    </div>

    <tui-scrollbar>
      <app-chats-list [items]="searchChats ? searchChats : chats"></app-chats-list>
    </tui-scrollbar>
  </div>
</div>
